import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Lecteur vidéo HTML5 simple, plein support range/streaming.
 *
 * Props :
 *  - src       : URL relative ou absolue
 *  - poster    : URL image affichée avant la lecture
 *  - caption   : légende affichée sous le lecteur
 *  - height    : hauteur (défaut 480px)
 *  - contentType : type MIME (défaut video/mp4)
 */
export default function VideoPlayer({ src, poster, caption = "", height = "480px", contentType = "video/mp4" }) {
  const full = src?.startsWith("http") ? src : `${BACKEND}${src}`;
  const posterFull = poster?.startsWith("http") ? poster : poster ? `${BACKEND}${poster}` : undefined;

  return (
    <div className="relative rounded-2xl overflow-hidden border border-[#E2E5F1] bg-[#0F1A3D]" data-testid="video-player">
      <video
        controls
        playsInline
        preload="metadata"
        poster={posterFull}
        style={{ width: "100%", height, objectFit: "cover", display: "block" }}
        data-testid="video-element"
      >
        <source src={full} type={contentType} />
        Votre navigateur ne supporte pas la lecture vidéo HTML5.
      </video>
      {caption && (
        <div className="absolute bottom-14 left-3 right-3 bg-[#0F1A3D]/80 backdrop-blur text-white text-xs px-3 py-2 rounded-md font-medium pointer-events-none">
          {caption}
        </div>
      )}
      <div className="absolute top-3 right-3 bg-white/95 text-[10px] uppercase tracking-wider font-bold text-[#E91E63] px-2.5 py-1 rounded pointer-events-none">
        Vidéo
      </div>
    </div>
  );
}
